export default __webpack_public_path__ + "static/media/4.66480192.jpeg";